import uiEnums from 'enums/ui';
import appSelectors from 'selectors/app';
import { getInPercentageRollout, getWithinOfficeHours } from 'selectors/configuration';

// Snowplow Types
const CONTEXT_AB_TEST = 'iglu:com.gladly.sidekick/context_ab_test/jsonschema/1-0-1';
const CONTEXT_GLADLY = 'iglu:com.gladly/context_gladly/jsonschema/1-0-0';
const CONTEXT_SEARCH = 'iglu:com.gladly/context_search/jsonschema/1-0-1';
const CONTEXT_SEARCH_RESULT = 'iglu:com.gladly/context_search_result/jsonschema/1-0-0';
const CONTEXT_QUICK_ACTION = 'iglu:com.gladly.sidekick/context_quick_action/jsonschema/1-0-0';
const CONTEXT_WIDGET = 'iglu:com.gladly.sidekick/context_widget/jsonschema/2-3-1';

const EVENT_ONBOARDING_SUBMITTED = 'iglu:com.gladly.sidekick/event_onboarding_submitted/jsonschema/1-0-0';
const EVENT_CHAT_MESSAGE_RECEIVED = 'iglu:com.gladly.sidekick/event_chat_message_received/jsonschema/1-0-1';
const EVENT_CHAT_MESSAGE_SENT = 'iglu:com.gladly.sidekick/event_chat_message_sent/jsonschema/2-0-0';
const EVENT_LINK_CLICKED = 'iglu:com.gladly.sidekick/event_link_clicked/jsonschema/1-1-0';
const EVENT_SCREEN_VIEWED = 'iglu:com.gladly.sidekick/event_screen_viewed/jsonschema/1-0-0';
const EVENT_SEARCHED = 'iglu:com.gladly.sidekick/event_searched/jsonschema/1-0-0';
const EVENT_WIDGET_LOADED = 'iglu:com.gladly.sidekick/event_widget_loaded/jsonschema/1-0-0';
const EVENT_WIDGET_OPENED = 'iglu:com.gladly.sidekick/event_widget_opened/jsonschema/2-0-0';

const location_map = {
  [uiEnums.LOCATIONS.HOME]: 'home',
  [uiEnums.LOCATIONS.ANSWER]: 'answer',
  [uiEnums.LOCATIONS.CHAT]: 'chat',
  [uiEnums.LOCATIONS.OFFICE_HOURS]: 'after_hours',
};

let isSnowplowInitialized;

function initializeSnowplow(state) {
  if (isSnowplowInitialized) {
    return;
  }

  let config = state.configuration.config;
  if (!config.snowplowEndpoint) {
    return;
  }

  window.gladly_snowplow('newTracker', 'cf', config.snowplowEndpoint, {
    // Initialize a tracker
    appId: 'sidekick',
    forceSecureTracker: true,
  });
  isSnowplowInitialized = true;
}

export function setSnowplowUserId(state, userId) {
  try {
    initializeSnowplow(state);
    window.gladly_snowplow('setUserId', userId);
  } catch (error) {
    // Analytics error should not interupt application logic
    // Should add this to Sentry
    console.log('Failed to set userId', error); // eslint-disable-line no-console
  }
}

export function trackSnowplowEvent(state, eventSchema, data = {}, contexts = []) {
  try {
    initializeSnowplow(state);

    let bucketId = state.configuration.onboardingTypeTestBucket;
    let config = state.configuration.config;
    let location = state.ui.locationHistory[state.ui.locationHistory.length - 1];
    let screen = location_map[location];
    let endpointAddress = appSelectors.getAppId(state.app);
    let platform = appSelectors.getPlatform(state).toUpperCase();

    window.gladly_snowplow(
      'trackUnstructEvent',
      {
        schema: eventSchema,
        data,
      },
      [
        {
          schema: CONTEXT_WIDGET,
          data: {
            screen,
            visibility: state.ui.isVisible ? (state.ui.isMinimized ? 'minimized' : 'open') : 'hidden',
            isInOfficeHours: getWithinOfficeHours(state.configuration),
            isThrottled: !getInPercentageRollout(state.configuration),
            smoochAppId: config.providerId,
            endpointAddress,
            platform,
          },
        },
        {
          schema: CONTEXT_GLADLY,
          data: {
            orgId: config.orgId,
            stage: config.gladlyStage,
            site: config.gladlySite,
          },
        },
        {
          schema: CONTEXT_AB_TEST,
          data: {
            onboardingType: bucketId,
          },
        },
        ...contexts,
      ]
    );
  } catch (error) {
    // Analytics error should not interupt application logic
    // Should add this to Sentry
    console.log('Failed to track event', error); // eslint-disable-line no-console
  }
}

export default {
  CONTEXT_AB_TEST,
  CONTEXT_GLADLY,
  CONTEXT_SEARCH_RESULT,
  CONTEXT_SEARCH,
  CONTEXT_QUICK_ACTION,
  CONTEXT_WIDGET,

  EVENT_CHAT_MESSAGE_RECEIVED,
  EVENT_CHAT_MESSAGE_SENT,
  EVENT_ONBOARDING_SUBMITTED,
  EVENT_LINK_CLICKED,
  EVENT_SCREEN_VIEWED,
  EVENT_SEARCHED,
  EVENT_WIDGET_LOADED,
  EVENT_WIDGET_OPENED,
};
